import goTopButton from '@/components/GoTopButton'
import { useToast } from 'vue-toast-notification'
import { Modal } from 'bootstrap';

export default {

  components: {
    goTopButton
  },

  data () {
    return {
      permissions: JSON.parse(sessionStorage.getItem('user')).permissions,
      responseErr: null,
      isProcessing: false,
      product: null
    }
  },

  created () {
    this.product = this.$store.state.products.product
    if (!this.product || !this.product.prb1 || !this.product.prb7) {
      this.$store.dispatch('products/invalidData', 'PRODUCT_EMPTY')
      this.$router.push({ name: 'product-list' })
    }
    else {
      this.$store.dispatch('products/resetInvalidData')
      this.getDetail()
    }
  },

  methods: {
    hasPermission (permission) {
      if (!String.prototype.includes) {
        return this.permissions.indexOf(permission, 0) !== -1
      } else {
        return this.permissions.includes(permission)
      }
    },
    async getDetail () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('products/resetDetail')
      await this.$store.dispatch('products/detail', {
        idDistributeur: this.product.prb7,
        idProduct: this.product.prb1
      }).then(
        () => {
          this.isProcessing = false
        },
        error => {
          console.log(error)
          this.isProcessing = false
          this.responseErr = error.responseCode || error || 'BAD_REQUEST'
        }
      )
    },

    async showEdit (product) {
      this.$store.dispatch('products/setProduct', {
        prb1: product.prb1,
        prb7: product.prb7
      })
      this.$router.push({ name: 'product-edit' })
    },

    async showCreate (product) {
      this.$store.dispatch('products/setProduct', {
        prb1: product.prb1,
        prb7: product.prb7
      })
      this.$router.push({ name: 'product-copy' })
    },

    exportProduct(product) {
      let jsonProduct = {}
      jsonProduct['parent'] = null
      for (var i in product) {
        jsonProduct[product[i].fieldName] = {}
        for (var j in product[i].params) {
          if (product[i].params[j].value.length > 1) {
            jsonProduct[product[i].fieldName][product[i].params[j].fieldName] = ''
            product[i].params[j].value.map((value, index, array) => {
              jsonProduct[product[i].fieldName][product[i].params[j].fieldName] += index === array.length -1 ? value : value + '\n'
            })
          }
          else if (product[i].params[j].fieldName != 'prb7' && product[i].params[j].value[0] == '') {
            jsonProduct[product[i].fieldName][product[i].params[j].fieldName] = null
          }
          else if (product[i].params[j].outOnly) {
            jsonProduct[product[i].fieldName][product[i].params[j].fieldName] = null
          }
          else {
            jsonProduct[product[i].fieldName][product[i].params[j].fieldName] = product[i].params[j].value[0]
          }
        }
      }
      jsonProduct['status'] = 'ACTIVE'
      // Convert the JSON array to a string
      const jsonString = JSON.stringify(jsonProduct);

      // Copy the string to the clipboard
      if (!navigator.clipboard) {
        let copyModal = new Modal(document.getElementById('copyModal'))
        copyModal.show()
        document.getElementById('copyModalText').innerHTML = jsonString
      }
      else {
        navigator.clipboard.writeText(jsonString)
        .then(() => {
          const $toast = useToast()
          $toast.open({
            message: this.$i18n.t('label.product.productCopied'),
            type:'default',
            position: 'bottom',
            duration: 5000,
            dismissible:true
          });
        })
        .catch(err => {
            console.error('Failed to copy JSON array: ', err);
        });
      }
    }
  }
}
